// extracted by mini-css-extract-plugin
export default {"header":"_header_5FUSbE","title":"_title_gE+VxH","form-body":"_form-body_MoOmtG","body":"_body_c823Nn","right-hand":"_right-hand_N4NKX7","left-hand":"_left-hand_ez8jhc"};